// AboutMe.jsx
import React from "react";
import { motion } from "framer-motion";
import {
  SiReact,
  SiJavascript,
  SiTypescript,
  SiNodedotjs,
  SiMongodb,
  SiPostgresql,
  SiNextdotjs,
  SiDocker,
} from "react-icons/si";

const skills = [
  { icon: <SiReact />, label: "React", color: "#61DAFB" },
  { icon: <SiJavascript />, label: "JavaScript", color: "#F7DF1E" },
  { icon: <SiTypescript />, label: "TypeScript", color: "#3178C6" },
  { icon: <SiNextdotjs />, label: "Next.js", color: "#000000" },
  { icon: <SiNodedotjs />, label: "Node.js", color: "#43853D" },
  { icon: <SiMongodb />, label: "MongoDB", color: "#4DB33D" },
  { icon: <SiPostgresql />, label: "PostgreSQL", color: "#336791" },
  { icon: <SiDocker />, label: "Docker", color: "#2496ED" },
];

const AboutMe = () => {
  return (
    <section
      id="about"
      className="mt-20 px-6 w-full flex flex-col lg:text-left"
    >
      {/* Title */}
      <div className="w-full max-w-5xl mx-auto text-left">
        <h2 className="text-gray-500 dark:text-gray-400 text-sm uppercase tracking-wide mb-1">
          About
        </h2>
        <h3 className="text-3xl sm:text-4xl font-semibold text-gray-900 dark:text-white mb-10">
          Me
        </h3>
      </div>

      {/* Card */}
      <motion.div
        initial={{ opacity: 0, y: 40 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.7 }}
        className="w-full max-w-5xl mx-auto flex flex-col lg:flex-row items-center gap-10"
      >
        {/* Avatar */}
        <div className="rounded-2xl overflow-hidden shadow-xl border border-gray-300/30 dark:border-gray-700/40">
          <img
            src="/avatar.png"
            alt="profile"
            className="w-64 h-64 object-cover bg-yellow-400"
          />
        </div>

        {/* Text */}
        <div className="flex-1">
          <h4 className="text-2xl sm:text-3xl font-semibold text-gray-900 dark:text-white">
            Ashish Karche
          </h4>

          <p className="mt-4 text-base text-gray-600 dark:text-gray-300 leading-relaxed max-w-xl">
            I'm a Full Stack web developer. I love building products to solve
            real-world problems. I'm specialized in building UI.
          </p>

          {/* Skills */}
          <p className="mt-8 mb-3 font-medium text-gray-800 dark:text-gray-200">
            Skills
          </p>

          <div className="flex flex-wrap gap-4">
            {skills.map((s, i) => (
              <div key={i} className="relative group">
                <div
                  style={{ color: s.color }}
                  className="text-2xl p-2 rounded-lg
                  bg-gray-200/70 dark:bg-gray-800 
                  text-gray-900 dark:text-white
                  hover:scale-110 transition-transform cursor-pointer"
                >
                  {s.icon}
                </div>

                {/* Tooltip */}
                <span
                  className="absolute bottom-11 left-1/2 -translate-x-1/2
                  opacity-0 group-hover:opacity-100 transition
                  text-xs font-medium px-2 py-1 rounded-md whitespace-nowrap
                  bg-black/90 text-white pointer-events-none"
                >
                  {s.label}
                </span>
              </div>
            ))}
          </div>
        </div>
      </motion.div>
    </section>
  );
};

export default AboutMe;
